"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportType = exports.ReportRunStatus = void 0;
var ReportRunStatus;
(function (ReportRunStatus) {
    // report generetion has been send to the queue
    ReportRunStatus["QUEUED"] = "queued";
    // report generation is in progress
    ReportRunStatus["RUNNING"] = "running";
    ReportRunStatus["COMPLETED"] = "completed";
    ReportRunStatus["FAILED"] = "failed";
})(ReportRunStatus = exports.ReportRunStatus || (exports.ReportRunStatus = {}));
var ReportType;
(function (ReportType) {
    ReportType["SNAPSHOT"] = "snapshot";
    ReportType["PERIOD"] = "period";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
